import strings from 'strings';

export const TIME_FRAME_MAP = {
  FixedHour: {
    id: 'fixedHour',
    title: 'Fixed Hour'
  },
  TimeRange: {
    id: 'timeRange',
    title: 'Time Range'
  }
};

const INTERVIEW_LINK_REGEX = /^\s*https?:\/\/[^\s/$.?#]\S+\s*$/i;

export const INTERVIEW_LINK_VALIDATION = {
  pattern: {
    value: INTERVIEW_LINK_REGEX,
    message: strings.sendoutsV2.form.sections.interviewDetails.errors.invalidInterviewLink
  }
};
